import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { EntityId } from '@Models';
import Repeater from '@Utils/Repeater';
import { FormattedMessage, useIntl } from 'react-intl';
import { AvailableUnitCategoryView } from '@Selectors/builder/myArmyList/make/unit/new/view/AvailableUnitCategoryView';

const ReduxFormCategorySelect: React.FC = (field: any) => (
  <FormGroup row={false}>
    {field.label && (<Label><FormattedMessage {...field.label} /></Label>)}
    <small>{field.value}</small>
    <select {...field.input} disabled={field.disabled} className="form-control">
      {field.placeHolder && (<option value="" disabled={true}>
        <FormattedMessage {...field.placeHolder} />
      </option>)}
      <Repeater data={field.datas} indexPrefix='category'>
        {
          (item: AvailableUnitCategoryView) =>
            <optgroup label={useIntl().formatMessage({id: item.label})}>
              <Repeater data={item.options} indexPrefix='option'>
                {
                  (item: EntityId<number>) =>
                    <option value={item.id}>
                      {item.name}
                    </option>
                }
              </Repeater>
            </optgroup>
        }
      </Repeater>
    </select>
    {field.meta.touched && field.meta.error && (
      <p className="text-danger"><FormattedMessage id={field.meta.error} /></p>
    )}
  </FormGroup>
);

export default ReduxFormCategorySelect;
